import { imagePreview } from "./imagePreview";

export default {
  imagePreview
}



// WEBPACK FOOTER //
// ./src/utils/directives/index.js